import Entity from '../../../../core/domain/entity';
import UniqueEntityID from '../../../../core/domain/unique_entity_id';
import { DietitianId } from '../dietitian';
import { Picture } from '../picture/picture';

export interface BillParamsProps {
  dietitianId: DietitianId;
  logo?: Picture | undefined;
  logoPosition?: 'left' | 'center' | 'right' | undefined;
  logoSize?: 'small' | 'medium' | 'large' | undefined;
  sign?: Picture | undefined;
  signSize?: 'small' | 'medium' | 'large' | undefined;
  socialReason?: string | undefined;
  siren?: string | undefined;
  registrationNumber?: string | undefined;
  address?: string | undefined;
  zip?: string | undefined;
  city?: string | undefined;
  country?: string | undefined;
  phoneNumber?: string | undefined;
  email?: string | undefined;
  tax: 'with' | 'without' | 'both';
  taxNumber?: string | undefined;
  taxRate?: number | undefined;
  noTaxMention: boolean;
  footer?: string | undefined;
  previewUrl?: string | undefined;
  createdAt?: Date | undefined;
  updatedAt?: Date | undefined;
  rcs: boolean | undefined;
  late: boolean | undefined;
  aga: boolean | undefined;
  identifier?: string | undefined;
  identifierId?: number | undefined;
  delayedIdentifier?: boolean | undefined;
  delayedReason?: string | undefined;
  identifierStatus?: string | undefined;
  identifierStatusMessage?: string | undefined;
  otherIdentifiers?: { identifier: string; status: string }[] | undefined;
}

export class BillParams extends Entity<BillParamsProps> {
  get dietitianId(): DietitianId {
    return this.props.dietitianId;
  }

  get logo(): Picture | undefined {
    return this.props.logo;
  }

  get logoPosition(): 'left' | 'center' | 'right' | undefined {
    return this.props.logoPosition;
  }

  get logoSize(): 'small' | 'medium' | 'large' | undefined {
    return this.props.logoSize;
  }

  get sign(): Picture | undefined {
    return this.props.sign;
  }

  get signSize(): 'small' | 'medium' | 'large' | undefined {
    return this.props.signSize;
  }

  get socialReason(): string | undefined {
    return this.props.socialReason;
  }

  get siren(): string | undefined {
    return this.props.siren;
  }

  get registrationNumber(): string | undefined {
    return this.props.registrationNumber;
  }

  get address(): string | undefined {
    return this.props.address;
  }

  get zip(): string | undefined {
    return this.props.zip;
  }

  get city(): string | undefined {
    return this.props.city;
  }

  get country(): string | undefined {
    return this.props.country;
  }

  get phoneNumber(): string | undefined {
    return this.props.phoneNumber;
  }

  get email(): string | undefined {
    return this.props.email;
  }

  get tax(): 'with' | 'without' | 'both' {
    return this.props.tax;
  }

  get taxNumber(): string | undefined {
    return this.props.taxNumber;
  }

  get taxRate(): number | undefined {
    return this.props.taxRate;
  }

  get noTaxMention(): boolean {
    return this.props.noTaxMention;
  }

  get footer(): string | undefined {
    return this.props.footer;
  }

  get previewUrl(): string | undefined {
    return this.props.previewUrl;
  }

  get createdAt(): Date | undefined {
    return this.props.createdAt;
  }

  get updatedAt(): Date | undefined {
    return this.props.updatedAt;
  }

  get rcs(): boolean | undefined {
    return this.props.rcs;
  }

  get late(): boolean | undefined {
    return this.props.late;
  }

  get aga(): boolean | undefined {
    return this.props.aga;
  }

  get identifier(): string | undefined {
    return this.props.identifier;
  }

  get identifierId(): number | undefined {
    return this.props.identifierId;
  }

  get delayedIdentifier(): boolean | undefined {
    return this.props.delayedIdentifier;
  }

  set delayedIdentifier(value: boolean | undefined) {
    this.props.delayedIdentifier = value;
  }

  get delayedReason(): string | undefined {
    return this.props.delayedReason;
  }

  set delayedReason(value: string | undefined) {
    this.props.delayedReason = value;
  }

  get identifierStatus() {
    return this.props.identifierStatus;
  }

  get identifierStatusMessage() {
    return this.props.identifierStatusMessage;
  }

  get otherIdentifiers() {
    return this.props.otherIdentifiers;
  }

  private constructor(props: BillParamsProps, id?: UniqueEntityID) {
    super(props, id);
  }

  copyWith(props: BillParamsProps): BillParams {
    return BillParams.create(
      {
        ...this.props,
        ...props,
      },
      this.id,
    );
  }

  public static create(
    props: BillParamsProps,
    id?: UniqueEntityID,
  ): BillParams {
    return new BillParams(props, id);
  }
}
